export enum B2C_BALANCE_ELIGIBILITY {
    LOW_BALANCE = "LOW_BALANCE",
    UNLIMITED = "UNLIMITED",
}

export interface BillToCompanyWidgetData {
    title: string;
    enabled: boolean;
    balance?: number;
    icon: string;
    balanceEligibility?: B2C_BALANCE_ELIGIBILITY;
    disableMessage?: string;
}
